import SpellsFilterAdvancedFilterLabel from "./SpellsFilterAdvancedFilterLabel";

export default SpellsFilterAdvancedFilterLabel;
export { SpellsFilterAdvancedFilterLabel };
